import React, { useContext } from "react";

import "./unregistered-email.styles.css";
import Button from "../form-components/button";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRectangleXmark } from "@fortawesome/free-solid-svg-icons";
import { UnregisteredEmailContext } from "../../contexts/unregistered-email-context";
import { SignUpModalContext } from "../../contexts/signup-modal-context";

const UnregisteredEmail = () => {
  const { setOpenUnregisteredEmailModal } = useContext(
    UnregisteredEmailContext
  );
  const { setOpenSignUpModal } = useContext(SignUpModalContext);

  const handleModelClose = () => {
    setOpenUnregisteredEmailModal(false);
  };

  const handleSignUpClick = () => {
    setOpenSignUpModal(true);
    setOpenUnregisteredEmailModal(false);
  };

  return (
    <>
      <div className="unregistered-modal">
        <div className="unregistered-modal-content">
          <div className="unregistered-modal-header">
            <Button
              className="unregistered-modal-close-button"
              onClick={handleModelClose}
            >
              <FontAwesomeIcon
                icon={faRectangleXmark}
                style={{ color: "#363832" }}
                size="xl"
              />
            </Button>
          </div>

          <div className="unregistered-modal-heading">
            <h1>Looks like we don't have an account with that email address</h1>
          </div>

          <p>Sign up to create an account</p>

          <div className="unregistered-button-container">
            <Button
              type="submit"
              buttonType="lowlandsGreen"
              onClick={handleSignUpClick}
            >
              Sign up
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnregisteredEmail;
